import React from 'react';
import styled, {css} from 'styled-components';
import {primitiveColors} from '../../../../styles/template';
import Icon from '../Icon/Icon'

interface Props {
    dark?: boolean
}


const LoaderContainer = styled.div<{ $dark?: boolean }>`
	margin: auto;
	text-align: center;
	& svg {
		width: 2rem;
		height: 2rem;
	}
	
	& .spinner {
        animation: rotate 2s linear infinite;
    }
    
    & .path {
	    stroke: ${primitiveColors.gray[50]};
        ${({ $dark }) => $dark && css`
            stroke: ${primitiveColors.gray[300]};
        `}
	    stroke-linecap: round;
	    animation: dash 1.5s ease-in-out infinite;
	    stroke-width: 10px;
	    r: 2rem;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
	        stroke-dasharray: 1, 150;
	        stroke-dashoffset: 0;
        }
        50% {
	        stroke-dasharray: 90, 150;
	        stroke-dashoffset: -35;
        }
        100% {
	        stroke-dasharray: 90, 150;
	        stroke-dashoffset: -124;
        }
    }
`

const Loader : React.FC<Props> = props => {
    const {dark} = props;
    return (
        <LoaderContainer $dark={dark}>
            <Icon name='Loader' />
        </LoaderContainer>
    )
}

export default Loader;
